export default __webpack_public_path__ + "static/media/dst-beskæftigede.53d98645.pdf";